import React from 'react';
import { LANGUAGES } from '../../helpers/reportConsts';
import styles from './LanguageIndicator.module.scss';
const LanguageIndicator = ({
  languages
}) => {
  const languageList = LANGUAGES.filter(obj => languages.split("_").includes(obj.iso));
  return <>
      {languageList.map(lang => <div key={lang.iso} className={`${styles['language-indicator']} ${styles[lang.iso]}`}>{lang.abbreviation}</div>)}
    </>;
};
export default LanguageIndicator;